import React, {useMemo} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import orderBy from "lodash/orderBy";

import MenuList from '@mui/material/MenuList';

import {getLookList} from "../../../lookNavigation/lookFunctions";
import {getFeatureGroupName} from "../../../../../misc/helpers";
import {setLookActiveCategory, setLookPageOpened} from "../../../../../actions/lookFunctions";
// import GroheCategoriesMenuItemWizard from "./groheCategoriesMenuItemWizard";
import {setGroheWizardName} from "../../../../../actions/groheQuotingToolFunctions";
import GroheCategory from "./groheCategory";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import LookMainWizardList from "../../../lookNavigation/lookMain/lookMainWizardList";
import {ROUTES} from "../../../../../routes";
import MaterialSpinner from "../../../../ui/materialSpinner";

const GroheCategoriesMenu = (props) => {

  const {intl, fabricatorData, isAccessory, showWizardItems, location, visualizersLoadedLength,
    qtCategoriesLoadedLength} = props;

  const isShopPage = location.pathname.includes(ROUTES.shop);

  let featureGroups = useMemo(() => {
    return getLookList(false, true, false, isShopPage, true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visualizersLoadedLength, qtCategoriesLoadedLength, isShopPage]);
  const featureGroupNameSort = (lmFeature) => getFeatureGroupName(lmFeature.featureGroup, intl, fabricatorData)
  featureGroups = orderBy(featureGroups,[featureGroupNameSort], ['asc'])

  // console.log("featureGroups", featureGroups);
  if (!featureGroups) {
    return null
  }

  const ACCESSORIES = ["paper_holder", "robe_hook", "towel_bar", "towel_ring"];
  const acc_groups = featureGroups.filter(parentObject => ACCESSORIES.includes(parentObject.partId));
  if (acc_groups.length && IS_PRODUCT_JOURNEY) {
    featureGroups = isAccessory ? acc_groups : featureGroups.filter(parentObject => !ACCESSORIES.includes(parentObject.partId));
    if (!isAccessory) {
      featureGroups.push({partId: "submenu_accessories"});
    }
  }

  return (
    <div className="grohe-section__content">
      {!qtCategoriesLoadedLength ? <MaterialSpinner/> : (
        <MenuList>
          {featureGroups.map(lmFeature => {
            return <GroheCategory key={lmFeature.partId} parentObject={lmFeature} />
          })}
          {showWizardItems ? <LookMainWizardList/> : null}
          {/*<GroheCategoriesMenuItemWizard/>*/}
        </MenuList>
      )}
    </div>
  )
};

GroheCategoriesMenu.propTypes = {
  isAccessory: PropTypes.bool,
  showWizardItems: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {visualizersLoaded} = store.serverState;
  const {qtCategoriesLoaded} = store.qtState;

  return {
    fabricatorData: store.fabricatorState,
    visualizersLoadedLength: visualizersLoaded.length,
    qtCategoriesLoadedLength: qtCategoriesLoaded.length,
  };
};

const mapDispatchToProps = {
  setLookActiveCategory,
  setLookPageOpened,
  setGroheWizardName,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheCategoriesMenu)
  )
)
